import React, { ChangeEvent, useCallback, useRef, useState } from "react";
import { KontaktSearchQuery } from "../../../ts/CP";
import Button from "../../ui/Button/Button";
import "./Header.scss";
import { useEditableKontakt, useKontakty } from "./KontaktyWrapper";

import { BiEditAlt } from "react-icons/bi";
import { BsSearch } from "react-icons/bs";
import { FaFileExport, FaFileImport, FaMoneyCheckAlt } from "react-icons/fa";
import { IoMdAdd, IoMdClose, IoMdList } from "react-icons/io";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { RiDeleteBin7Line } from "react-icons/ri";

import { Box } from "@mui/material";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { readString } from "react-papaparse";
import { connect } from "react-redux";
import { Link } from "react-router";
import { kontaktModel } from "../../../api/models/kontaktModel";
import ExportButton from "../../../exports/ExportButton";
import { useQueryWithPopupErrorHandling } from "../../../providers/utils/hooks";
import { ADD_KONTAKTY } from "../../../redux/actions/kontaktyActions";
import { useSelector } from "../../../redux/store";
import { Auth } from "../../../ts/Auth";
import { Skupina } from "../../../ts/CSSkupiny";
import { Kontakt as KontaktType } from "../../../ts/Kontakt";
import ReduxState from "../../../ts/Redux";
import { ConfirmationType } from "../../../ts/UI";
import { mapCSVDataToJson } from "../../../utils";
import Confirmation from "../../ui/Confirmation/Confirmation";
import ImportPopup, {
  ImportPopupInterface,
} from "../../ui/ImportPopup/ImportPopup";
import Input from "../../ui/Input/Input";
import { LazyAutocomplete } from "../../ui/LazyAutocomplete/LazyAutocomplete";

interface Props {
  index: number;
  totalCount: number;
  handleSearch(query: KontaktSearchQuery): void;
  auth: Auth;
  refreshKontakts: () => void;
  activeQuery?: KontaktSearchQuery | null;
  isLoading?: boolean;
}
const Header: React.FC<Props> = ({
  index,
  handleSearch,
  auth,
  totalCount,
  refreshKontakts,
  activeQuery,
  isLoading,
}: Props) => {
  const [kontakt, , setIndex] = useKontakty();
  const [
    editable,
    setEditable,
    newKontakt,
    setNewKontakt,
    listShown,
    setListShown,
  ] = useEditableKontakt();
  const [searchActive, setSearchActive] = useState(false);
  const [query, setQuery] = useState<KontaktSearchQuery>({
    klient: "",
    skupina: "",
    obec: "",
    okres: "",
    meno: "",
    priezvisko: "",
    email: "",
  });
  const { call } = useQueryWithPopupErrorHandling();
  const [errors, setErrors] = useState<any>({});

  const { cs_skupiny } = useSelector((state) => ({
    cs_skupiny: state.cs_skupiny,
  }));

  const deleteConfirmation = useRef<ConfirmationType>(null);

  const isEditableOrNewOrNewListShown = listShown || editable || newKontakt;
  const importPopupRef = useRef<ImportPopupInterface>(null);

  const addKontakty = useCallback((kontakty: KontaktType[]) => {
    call(
      () => kontaktModel.addBulk({ kontakty }),
      "Import kontaktov nebol úspešný",
      "Kontakty boli úspešne pridané",
      () => {
        importPopupRef.current?.close();
      }
    );
  }, []);

  const importKontakty = (e: ChangeEvent<HTMLInputElement>) => {
    let f = e.target.files?.[0];

    if (f) {
      let r = new FileReader();
      r.onload = async (e) => {
        let contents = e.target?.result;
        let csv = readString((contents as string).trim(), {
          header: true,
          complete: async ({ data, errors: parseErrors }) => {
            let mapped =
              parseErrors.length > 0 ? false : mapCSVDataToJson(data);
            console.log(mapped, data, parseErrors);

            if (mapped) {
              setErrors({});
              importPopupRef.current?.showPopup(data, (content) => {
                if (content) {
                  let mapped = mapCSVDataToJson(content);

                  if (mapped) {
                    addKontakty(mapped as KontaktType[]);
                  }
                }
              });
            } else {
              setErrors({ ...errors, import: "Nesprávny formát CSV súboru" });
            }
          },
        });
      };
      r.readAsText(f);
    }
  };

  const searchClick = () => {
    if (
      query.klient === "" &&
      query.skupina === "" &&
      query.obec === "" &&
      query.okres === "" &&
      query.meno === "" &&
      query.priezvisko === "" &&
      query.email === ""
    )
      return;

    setSearchActive(false);
    setQuery({
      klient: "",
      skupina: "",
      obec: "",
      okres: "",
      meno: "",
      priezvisko: "",
      email: "",
    });
    handleSearch(query);
  };

  const deleteKontakt = useCallback(() => {
    call(
      () => kontaktModel.deleteKontakt({ kontakt }),
      "Odstránenie kontaktu nebolo úspešné",
      "Kontakt bol odstraněný",
      () => {
        if (index + 1 === totalCount) {
          setIndex?.(index - 1);
        } else {
          refreshKontakts();
        }
      }
    );
  }, [kontakt, totalCount, index]);

  const inputKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") searchClick();
  };

  if (!kontakt || !setIndex) {
    return null;
  }

  return (
    <>
      <ImportPopup ref={importPopupRef} preventClosing />
      <div className="kontaktyHeader">
        <div className="up">
          <div>
            <Button
              disabled={listShown || editable}
              onClick={() => {
                setNewKontakt(!newKontakt);
              }}
            >
              {newKontakt ? (
                <>
                  {" "}
                  <IoMdClose
                    size={16}
                    style={{
                      marginRight: 10,
                    }}
                  />{" "}
                  ZRUŠIT
                </>
              ) : (
                <>
                  {" "}
                  <IoMdAdd
                    size={16}
                    style={{
                      marginRight: 10,
                    }}
                  />{" "}
                  VYTVORIŤ
                </>
              )}
            </Button>
          </div>

          <div>
            <Button
              disabled={listShown || newKontakt || kontakt._id === ""}
              onClick={() => {
                setEditable(!editable);
              }}
            >
              {editable ? (
                <>
                  {" "}
                  <IoMdClose
                    size={16}
                    style={{
                      marginRight: 10,
                    }}
                  />{" "}
                  ZRUŠIT
                </>
              ) : (
                <>
                  {" "}
                  <BiEditAlt
                    size={16}
                    style={{
                      marginRight: 10,
                    }}
                  />{" "}
                  UPRAVIŤ
                </>
              )}
            </Button>
          </div>

          <div
            style={{
              position: "relative",
            }}
          >
            <Confirmation
              title="Odstranit kontakt?"
              yes={() => deleteKontakt()}
              ref={deleteConfirmation}
              style={{
                top: "-100%",
                left: "-12.5%",
                whiteSpace: "nowrap",
              }}
            />
            <Button
              onClick={() => deleteConfirmation.current?.clickHandler()}
              disabled={isEditableOrNewOrNewListShown || kontakt._id === ""}
            >
              {" "}
              <RiDeleteBin7Line
                size={16}
                style={{
                  marginRight: 10,
                }}
              />{" "}
              ODSTRÁNIŤ
            </Button>
          </div>
          <div>
            <Button
              disabled={editable || newKontakt}
              onClick={() => setSearchActive(!searchActive)}
            >
              {" "}
              <BsSearch
                size={16}
                style={{
                  marginRight: 10,
                }}
              />{" "}
              VYHĽADAŤ
            </Button>
          </div>
        </div>
        {searchActive ? (
          <div className="searchCP">
            <Input
              value={query.klient}
              onChange={(e) => setQuery({ ...query, klient: e.target.value })}
              onKeyPress={inputKeyPress}
              borderColor="yellow"
              placeholder="Klient/Spoločnosť"
            />
            <Box className="styled-input-wrapper">
              <Box sx={{ mr: 2.5, minWidth: 220 }}>
                <LazyAutocomplete<Skupina>
                  enableFiltering
                  placeholder="Skupina"
                  data={cs_skupiny}
                  value={
                    cs_skupiny.find((i) => i._id === query.skupina) ?? null
                  }
                  getOptionLabel={(option) => option.nazev}
                  getOptionKey={(option) => option._id}
                  onChange={(item) =>
                    setQuery({ ...query, skupina: item?._id ?? "" })
                  }
                />
              </Box>
            </Box>
            <Input
              value={query.obec}
              onChange={(e) => setQuery({ ...query, obec: e.target.value })}
              onKeyPress={inputKeyPress}
              borderColor="yellow"
              placeholder="Obec"
            />
            <Input
              value={query.okres}
              onChange={(e) => setQuery({ ...query, okres: e.target.value })}
              onKeyPress={inputKeyPress}
              borderColor="yellow"
              placeholder="Okres"
            />
            <Input
              value={query.meno}
              onChange={(e) => setQuery({ ...query, meno: e.target.value })}
              onKeyPress={inputKeyPress}
              borderColor="yellow"
              placeholder="Meno"
            />
            <Input
              value={query.priezvisko}
              onChange={(e) =>
                setQuery({ ...query, priezvisko: e.target.value })
              }
              onKeyPress={inputKeyPress}
              borderColor="yellow"
              placeholder="Priezvisko"
            />
            <Input
              value={query.email}
              onChange={(e) => setQuery({ ...query, email: e.target.value })}
              onKeyPress={inputKeyPress}
              borderColor="yellow"
              placeholder="Email"
            />
            <Button
              disabled={
                query.klient === "" &&
                query.skupina === "" &&
                query.obec === "" &&
                query.okres === "" &&
                query.meno === "" &&
                query.priezvisko === "" &&
                query.email === ""
              }
              onClick={searchClick}
              style={{
                display: "flex",
              }}
            >
              {" "}
              <BsSearch
                size={16}
                style={{
                  marginRight: 10,
                }}
              />{" "}
              HLADAŤ
            </Button>
          </div>
        ) : null}
        <div className="middle">
          <div>
            <Button
              disabled={editable || newKontakt}
              onClick={() => setListShown(!listShown)}
            >
              {" "}
              <IoMdList
                size={16}
                style={{
                  marginRight: 10,
                }}
              />{" "}
              {listShown ? "ZATVORIŤ" : "ZOZNAM"}
            </Button>
          </div>
          <div>
            <Link to={`/obraty/kontakt/${kontakt._id}`}>
              <Button disabled={editable || newKontakt}>
                {" "}
                <FaMoneyCheckAlt
                  size={16}
                  style={{
                    marginRight: 10,
                  }}
                />{" "}
                OBRATY
              </Button>
            </Link>
          </div>
          <div>
            <Link to={`/cenove-ponuky/kontakt/${kontakt._id}`}>
              <Button disabled={editable || newKontakt}>
                {" "}
                <AiOutlineUnorderedList
                  size={16}
                  style={{
                    marginRight: 10,
                  }}
                />{" "}
                CENOVÉ PONUKY
              </Button>
            </Link>
          </div>
          {auth.user.function === "root" ? (
            <div
              style={{
                display: "flex",
              }}
            >
              <label htmlFor="kontakty-import">
                <div
                  className="styled-button yellow"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  <FaFileImport
                    size={16}
                    style={{
                      marginRight: 10,
                    }}
                  />{" "}
                  IMPORT KONTAKTOV
                </div>
                {errors.import ? (
                  <div className="error-message import">{errors.import}</div>
                ) : null}
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: 40,
                }}
              >
                <ExportButton
                  wrapperStyle={{ marginTop: 0 }}
                  buttonStyle={{ width: "auto" }}
                  type="kontakty"
                  label="EXPORT KONTAKTOV"
                  query={activeQuery ? JSON.stringify(activeQuery) : undefined}
                  icon={
                    <FaFileExport
                      size={16}
                      style={{
                        marginRight: 10,
                      }}
                    />
                  }
                />
              </div>
              <input
                type="file"
                style={{
                  display: "none",
                }}
                accept=".csv"
                onClick={(
                  e: React.MouseEvent<HTMLInputElement, MouseEvent>
                ) => {
                  const element = e.target as HTMLInputElement;
                  element.value = "";
                }}
                onChange={importKontakty}
                id="kontakty-import"
              />
            </div>
          ) : null}
        </div>
        <div className="down">
          <div>
            <Button
              color="dark"
              disabled={
                isEditableOrNewOrNewListShown || index === 0 || isLoading
              }
              onClick={() => setIndex(index - 1)}
            >
              {" "}
              <MdChevronLeft
                size={16}
                style={{
                  marginRight: 10,
                }}
              />{" "}
              PREDCHÁDZAJÚCI ZÁZNAM
            </Button>
          </div>
          <div>
            <Button
              color="dark"
              disabled={
                isEditableOrNewOrNewListShown ||
                index === totalCount - 1 ||
                totalCount === 0 ||
                isLoading
              }
              onClick={() => setIndex(index + 1)}
            >
              ĎALŠÍ ZÁZNAM{" "}
              <MdChevronRight
                size={16}
                style={{
                  marginLeft: 10,
                }}
              />{" "}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { ADD_KONTAKTY })(Header);
